<template>
        <footer id="kapcsolat" class="footer p-3 text-center d-flex flex-column align-items-center">
        <div class="d-flex justify-content-around align-items-center info-container flex-wrap">
            <div class="d-flex justify-content-center">
                <a href="/">
                    <CdnImage 
                        classes="footer-logo" 
                        src="https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/logo" 
                        fallbackSrc="./static/assets/logo.png"
                        alt="Veszprém Redőnyjavítás - Árnyék Guru"/>
                </a>
            </div>
            <div class="d-flex flex-column">
                    <h5>Elérhető vagyok</h5>
                    <h5>akár hétvégén is.</h5>
                    <h5>Keressen bizalommal!</h5>
                </div>
            <div class="d-flex flex-column">

                <div class="m-1 d-flex flex-column telephone">
                    <div>
                        <a href="tel:+36302766007" @click="googleAnalytics.fireDialEvent()">
                            <i class="bi bi-telephone-fill m-1"></i>
                            +36 (30) 276 6007
                        </a>
                    </div>
                    <div>
                        <a href="tel:+36305485302" @click="googleAnalytics.fireDialEvent()">
                            <i class="bi bi-telephone-fill m-1"></i>
                            +36 (30) 548 5302
                        </a>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column">    
                <div class="m-1">
                    <h4>Facebook Oldalunk</h4>
                </div>
                <div class="m-1">
                    <a href="https://www.facebook.com/profile.php?id=61573819387165" target="_blank" class="m-3 text-reset">
                        <i class="bi bi-facebook icon-font"></i>
                    </a>
                </div>
                <div class="m-1">     
                    <i class="bi bi-mailbox2 m-1"></i>
                    <a href="mailto:arnyekguru@gmail.com">
                        arnyekguru@gmail.com
                    </a>
                </div>
            </div>
        </div>
        &copy; Árnyék Guru 2025
    </footer>
</template>

<script>
import CdnImage from './CdnImage.vue';
import * as googleAnalytics from "@/utils/google-analytics-utils";

export default {
    name: "FooterBar",
  computed: {
    googleAnalytics() {
      return googleAnalytics
    }
  },
    components: {
        CdnImage,
    },
}
</script>

<style lang="scss" scoped>
@use '@/assets/style/common';
@use '@/assets/style/variables';
@use '@/assets/style/functions';

.footer {
    width: 100%;
    background: variables.$light-color;

    .info-container {
        width: 90%;
    }
}

.footer-logo {
    height: 150px;
}

.icon-font {
    font-size: 1.5rem;
}

.telephone {
    font-size: 1.5rem;
}
</style>